import React, { useEffect, useMemo, useState } from 'react'
import { Spin, message } from '@surecompanies/core_components'
import { getTerminationFileByPublicKey } from '../api/terminations-enrollment-platform-api-client'
import { TerminationFileRowDto } from '../api/dto/termination-file-row.dto'
import { AgGridReact } from '@ag-grid-community/react'
import { ColDef } from '@ag-grid-community/core'
import PageWrapper from '../../../PageWrapper'
import Page from 'layouts/Page'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import { CENSUS_MANAGEMENT_PATH } from '../constants'
import dayjs from 'dayjs'

const TerminationFileViewer = ({
  routeParams,
}: {
  routeParams: { importPublicKey: string }
}) => {
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState<TerminationFileRowDto[]>([])

  const columnDefs = useMemo<ColDef<TerminationFileRowDto>[]>(
    () => [
      { headerName: 'Employee ID', field: 'employeeId', flex: 1 },
      { headerName: 'First Name', field: 'firstName', flex: 1 },
      { headerName: 'Last Name', field: 'lastName', flex: 1 },
      {
        headerName: 'Termination Date',
        field: 'terminationDate',
        flex: 1,
        valueFormatter: ({ value }) => {
          return value ? dayjs.utc(value).format('MM/DD/YYYY') : ''
        },
      },
      {
        headerName: 'Status',
        field: 'status',
        flex: 1,
        tooltipValueGetter: (params) => {
          const msg = params.data?.errorMessage
          if (msg?.startsWith('Failed to confirm Terminations')) {
            return 'Failed to confirm Terminations'
          }
          return msg
        },
      },
    ],
    []
  )

  useEffect(() => {
    const fetchRows = async () => {
      setLoading(true)
      try {
        const data = await getTerminationFileByPublicKey(
          routeParams.importPublicKey
        )
        setRows(data.rows || [])
      } catch (err) {
        console.error(err)
        message.error('Failed to load termination file')
      } finally {
        setLoading(false)
      }
    }
    fetchRows()
  }, [routeParams.importPublicKey])

  return (
    <PageWrapper>
      <Page
        title="Termination File Review"
        breadcrumb={
          <BreadcrumbNav
            items={[
              {
                title: 'Bulk Terminations',
                path: `${CENSUS_MANAGEMENT_PATH}/bulk-terminations`,
              },
              { title: 'Termination File' },
            ]}
          />
        }
      >
        {loading ? (
          <Spin />
        ) : (
          <div className="ag-theme-alpine" style={{ height: 600 }}>
            <AgGridReact
              rowData={rows}
              columnDefs={columnDefs}
              pagination
              paginationPageSize={10}
              domLayout="autoHeight"
            />
          </div>
        )}
      </Page>
    </PageWrapper>
  )
}

export default TerminationFileViewer
